module.exports = function (isMobile, locale) {
  return {
    navList: [
    // {
    //     name: 'Whole-home Backup Power Solution',
    //     icons: '',
    //     detLink: `/${locale}/whole-home-backup-power-solution`,
    //     target: '_blank',
    // },
    {
      name: 'Whole-Home Backup',
      imgSrc: isMobile ? ['solutions_nav_whole_h5.webp', 'solutions_nav_whole_h5.jpg'] : ['solutions_nav_whole.webp', 'solutions_nav_whole.jpg'],
      detLink: "/".concat(locale, "/whole-home-backup-power-solution")
    }, {
      name: 'Mobile/Off-grid Home',
      imgSrc: isMobile ? ['solutions_nav_mm100_h5.webp', 'solutions_nav_mm100_h5.jpg'] : ['solutions_nav_mm100.webp', 'solutions_nav_mm100.jpg'],
      detLink: "/".concat(locale, "/ecoflow-power-kits/series")
    }
    // {
    //     name: 'Components',
    //     icons: '',
    //     detLink: `https://${locale}.ecoflow.com/collections/power-kits-components`,
    // },
    // {
    //     name: 'Power Calculator',
    //     icons: '',
    //     detLink: `/${locale}/calculators/power-kits`,
    //     target: '_blank',
    // },
    ],

    content: {
      headerData: [{
        type: 'large',
        name: 'Whole-Home Backup Power Solution',
        desc: 'Power Has Never Been This Easy.',
        imgSrc: isMobile ? ['solutions_bg_whole_h5.webp', 'solutions_bg_whole_h5.jpg'] : ['solutions_bg_whole.webp', 'solutions_bg_whole.jpg'],
        detLink: "/".concat(locale, "/whole-home-backup-power-solution")
      }, {
        type: 'large',
        name: 'Mobile/Off-grid Home Power Kits',
        desc: 'Simple. Smart. Compact.',
        imgSrc: isMobile ? ['solutions_bg_h5.webp', 'solutions_bg_h5.jpg'] : ['solutions_bg.webp', 'solutions_bg.jpg'],
        detLink: "/".concat(locale, "/ecoflow-power-kits/series"),
        comLink: 'https://ca.ecoflow.com/collections/power-kits-components',
        comText: 'Components'
      }],
      contextList: [
        // {
        //     type: 'small',
        //     name: 'Power Hub',
        //     desc: '5-in-1 Input and Output Hub',
        //     imgSrc: isMobile ? '/h5img/solutions/solutionslist1.png' : '/img/solutions/solutionslist1.jpg',
        //     imgHoverSrc: '/img/solutions/solutionslist1_hover.jpg',
        //     detLink: `https://${locale}.ecoflow.com/products/power-hub`,
        // },
        // {
        //     type: 'small',
        //     name: 'LFP Batteries',
        //     desc: '2–15kWh Storage Capacities',
        //     imgSrc: isMobile ? '/h5img/solutions/solutionslist2.png' : '/img/solutions/solutionslist2.jpg',
        //     imgHoverSrc: '/img/solutions/solutionslist2_hover.jpg',
        //     detLink: `https://${locale}.ecoflow.com/products/lfp-battery`,
        // },
        // {
        //     type: 'small',
        //     name: 'AC/DC Smart Distribution Panel',
        //     desc: '6+12 AC/DC Circuits for Your Appliances',
        //     imgSrc: isMobile ? '/h5img/solutions/solutionslist3.png' : '/img/solutions/solutionslist3.jpg',
        //     imgHoverSrc: '/img/solutions/solutionslist3_hover.jpg',
        //     detLink: `https://${locale}.ecoflow.com/products/ac-dc-smart-distribution-panel`,
        // },
        // {
        //     type: 'small',
        //     name: 'Power Kit Console',
        //     desc: 'Mount, Monitor and Control',
        //     imgSrc: isMobile ? '/h5img/solutions/solutionslist4.png' : '/img/solutions/solutionslist4.jpg',
        //     imgHoverSrc: '/img/solutions/solutionslist4_hover.jpg',
        //     detLink: `https://${locale}.ecoflow.com/products/power-kits-console`,
        // },
      ]
    }
  };
};